import React from "react";
import Home from "../../../components/Home/Home";

const Calculate = () => {
  return (
    <div>
      <Home></Home>
    </div>
  );
};

export default Calculate;
